import { Text, TextProps as ChakraTextProps } from '@chakra-ui/react'
import { TextProps } from './utils'

const Body = (props: TextProps & ChakraTextProps) => {
  const { children, ...textProps } = props
  return (
    <Text as="p" fontSize="md" fontWeight={400} {...textProps}>
      {children}
    </Text>
  )
}

export { Body }
